import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { VolunteerActivism, Public, Assessment } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import DrawerR from "./Drawer";
import LanguageSwitcher from "./LanguageSwitcher";

const Navigation = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { name: t("Dashboard"), path: "/", icon: "🏠" },
    { name: t("GECTitle"), path: "/gec", icon: "📊" },
    { name: t("HRCTitle"), path: "/hrc", icon: "🏥" },
    { name: t("MOPHTitle"), path: "/moph", icon: "⚕️" },
    { name: t("South CouncilTitle"), path: "/south", icon: "🌍" },
    { name: t("Analysis"), path: "/analysis", icon: "📈" },
    { name: t("FAQ"), path: "/faq", icon: "❓" },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #0c9fc1 0%, #4db6d1 100%)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >

        <Container maxWidth="xl">
          <Toolbar sx={{ py: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
              <VolunteerActivism 
                sx={{ 
                  fontSize: 32, 
                  mr: 2, 
                  color: 'white',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
                }} 
              />
              <Typography
                variant="h5"
                component={RouterLink}
                to="/"
                sx={{
                  fontFamily: '"Playfair Display", serif',
                  fontWeight: 700,
                  letterSpacing: '-0.5px',
                  textDecoration: "none",
                  color: "white",
                  textShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  }
                }}
              >
                {t("Lebanon Aid Tracker")}
              </Typography>
            </Box>

            {isMobile ? (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ 
                  display: { md: 'none' },
                  color: 'white',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.1)',
                  }
                }}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <Box sx={{ display: "flex", gap: 1, alignItems: 'center' }}>
                {navItems.map((item) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <Button
                      key={item.path}
                      component={RouterLink}
                      to={item.path}
                      startIcon={<span style={{ fontSize: '14px' }}>{item.icon}</span>}
                      sx={{
                        color: "white",
                        fontWeight: 600,
                        px: { xs: 1.5, md: 2.5 },
                        py: 1,
                        borderRadius: 0,
                        textTransform: 'none',
                        fontSize: { xs: '0.8rem', md: '0.9rem' },
                        background: isActive 
                          ? 'rgba(255, 255, 255, 0.2)' 
                          : 'transparent',
                        backdropFilter: isActive ? 'blur(10px)' : 'none',
                        border: isActive 
                          ? '1px solid rgba(255, 255, 255, 0.3)' 
                          : '1px solid transparent',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          background: 'rgba(255, 255, 255, 0.15)',
                          backdropFilter: 'blur(10px)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        },
                      }}
                    >
                      {item.name}
                    </Button>
                  );
                })}
                <LanguageSwitcher />
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      <DrawerR
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        navItems={navItems}
      />
    </>
  );
};

export default Navigation;
